/**
 * Store listeners setup for web app
 *
 * Only imports listeners that are relevant for web.
 * Mobile-specific listeners (Intercom, Pendo, native sync, etc.) are excluded.
 */

// Import listener infrastructure
export { listenerMiddleware, initListeners } from './listenerMiddleware';

// Import listeners (side effects)
import './holdingSyncFromTransactions'; // Ask QCS to rebuild holdings after investment txn edits
import './pauthDetection'; // Detect first-time PAUTH_INVALID_TOKEN transitions
import './receiptUploadInvalidation'; // Cancel receipt uploads before logout or dataset switch
import './receiptProcessingTracking'; // Track receipt upload and extraction outcomes
import './fiMigrationTracking'; // Track migration eligibility and reset session-only prompts
